// Purpose - Compact large numbers for dashboard tiles (e.g. 1K, 1.2M)

export const formatCompactNumber = (value) => {
  if (value === null || value === undefined) return "-";

  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K`;

  return value.toString();
};
